// @ts-nocheck
/**
 * Premium PDP — gallery + variant table integration.
 * Reuses shared weight/cart logic from plp-table-details.js.
 */
(function () {
  'use strict';

  var PDP_MAIN_WIDTHS = [375, 550, 750, 900, 1100, 1300, 1500, 1600, 1800, 2000];
  var PDP_MAIN_SIZES = '(min-width: 990px) 50vw, 100vw';
  var productLoadPromiseById = new Map();
  var controllersByRoot = new WeakMap();
  /** @type {WeakMap<HTMLElement, number>} */
  var hydrateGenerationByRoot = new WeakMap();

  function parseProduct(root) {
    var el = root.querySelector('[data-pdp-product-json]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getWmsApi() {
    return window.WMSInventory || window.AOneWmsAvailability || null;
  }

  function normalizeSku(value) {
    var api = getWmsApi();
    if (api && typeof api.normalizeSku === 'function') return api.normalizeSku(value);
    return String(value || '')
      .trim()
      .toUpperCase();
  }

  function normalizeSkuDisplay(value) {
    return String(value || '').trim();
  }

  function normalizeShopifyId(value) {
    var api = getWmsApi();
    if (api && typeof api.normalizeId === 'function') return api.normalizeId(value);
    if (value === null || value === undefined) return '';
    var stringValue = String(value).trim();
    if (!stringValue) return '';
    if (stringValue.indexOf('/') >= 0) return stringValue.split('/').pop() || '';
    return stringValue;
  }

  function warnPdpDev(message, meta) {
    var api = getWmsApi();
    if (api && typeof api.warnDev === 'function') {
      api.warnDev(message, meta);
      return;
    }
    if (typeof console === 'undefined' || typeof console.warn !== 'function') return;
    if (meta !== undefined) console.warn('[A-One PDP WMS]', message, meta);
    else console.warn('[A-One PDP WMS]', message);
  }

  function toFiniteNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
      var match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
      if (!match) return null;
      var n = Number(match[0]);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  }

  function formatWeight(weight) {
    var n = Number(weight);
    if (!Number.isFinite(n) || n <= 0) return '—';
    return n.toFixed(2) + 'g';
  }

  function getSharedWeightStore() {
    if (!window.__aoneWeightSharedStore) {
      window.__aoneWeightSharedStore = {
        rawBySku: Object.create(null),
        dataBySku: Object.create(null),
        pendingBySku: Object.create(null),
        pendingBatchByKey: Object.create(null),
      };
    }
    return window.__aoneWeightSharedStore;
  }

  function extractFromList(list, skuNeedle) {
    if (!Array.isArray(list)) return null;
    var needle = normalizeSku(skuNeedle);
    if (!needle) return null;
    for (var i = 0; i < list.length; i += 1) {
      var item = list[i];
      if (!item || typeof item !== 'object') continue;
      var sku = normalizeSku(item.sku || item.SKU || item.itemSku || item.item_sku);
      if (sku && sku === needle) return item;
    }
    return null;
  }

  function getStoreSkuEntry(store, sku) {
    if (!store || !store.skus) return null;
    var safeSku = normalizeSkuDisplay(sku);
    var key = normalizeSku(sku);
    if (!key && !safeSku) return null;
    var entry =
      (safeSku && store.skus.get(safeSku)) ||
      (key && store.skus.get(key)) ||
      (safeSku && store.skus.get(safeSku.toLowerCase())) ||
      null;
    if (entry) return entry;
    if (typeof store.skus.forEach !== 'function') return null;
    var matched = null;
    store.skus.forEach(function (value, mapKey) {
      if (matched) return;
      if (normalizeSku(mapKey) === key) matched = value;
    });
    return matched;
  }

  function getCachedNodeForSku(product, sku) {
    var displaySku = normalizeSkuDisplay(sku);
    var key = normalizeSku(sku);
    if (!key) return null;

    var wmsApi = getWmsApi();
    var productIdForWms = normalizeShopifyId(product && product.id);
    if (wmsApi && typeof wmsApi.getSkuAvailability === 'function' && productIdForWms) {
      var availability = wmsApi.getSkuAvailability(productIdForWms, key);
      if (
        availability &&
        (availability.loading ||
          availability.status === 'loading' ||
          availability.status === 'idle')
      ) {
        return { __pdpInventoryPending: true, sku: displaySku || key };
      }
      if (availability && availability.status === 'loaded') {
        return availability;
      }
    }
    if (
      wmsApi &&
      typeof wmsApi.isCartStateReady === 'function' &&
      !wmsApi.isCartStateReady()
    ) {
      return { __pdpInventoryPending: true, sku: displaySku || key };
    }
    if (wmsApi && typeof wmsApi.getInventoryBySku === 'function') {
      var inventory = wmsApi.getInventoryBySku(key);
      if (inventory && inventory.loading) {
        return { __pdpInventoryPending: true, sku: displaySku || key };
      }
      if (inventory && inventory.found !== false && !inventory.loading) {
        return {
          sku: inventory.sku,
          found: inventory.found,
          count: inventory.quantity,
          rawAvailableCount: inventory.rawAvailableCount,
          minWeight: inventory.minimumWeight,
          maxWeight: inventory.maximumWeight,
          weightGroups: inventory.weightGroups,
          availableOptions: inventory.availableOptions,
          storefrontStatus: inventory.storefrontStatus || inventory.status,
        };
      }
    }

    var shared = getSharedWeightStore();
    if (shared.rawBySku) {
      if (shared.rawBySku[key.toLowerCase()]) return shared.rawBySku[key.toLowerCase()];
      if (displaySku && shared.rawBySku[displaySku.toLowerCase()]) {
        return shared.rawBySku[displaySku.toLowerCase()];
      }
    }

    var store = window.AOneProductWeights;
    if (store) {
      var skuEntry = getStoreSkuEntry(store, displaySku || key);
      if (skuEntry && skuEntry.item) return skuEntry.item;

      var productId = normalizeShopifyId(product && product.id);
      var productNode = productId && store.products && store.products.get(productId);
      if (productNode) {
        var fromSkus = extractFromList(productNode.skus, key);
        if (fromSkus) return fromSkus;
        var fromItems = extractFromList(productNode.items, key);
        if (fromItems) return fromItems;
      }
    }

    return null;
  }

  /**
   * Normalize a cached WMS SKU node into a stable PDP row payload.
   * @param {unknown} node
   * @param {string} sku
   */
  function normalizePdpWmsSkuData(node, sku) {
    var safeSku = normalizeSkuDisplay(sku);
    if (!node || typeof node !== 'object') {
      return {
        sku: safeSku,
        found: false,
        count: 0,
        rawAvailableCount: 0,
        minWeight: null,
        maxWeight: null,
        weightGroups: [],
        availableOptions: [],
        storefrontStatus: 'COMING_SOON',
      };
    }
    var obj = node;
    var availableOptions = Array.isArray(obj.availableOptions)
      ? obj.availableOptions
      : Array.isArray(obj.availableWeights)
        ? obj.availableWeights
        : [];
    var found = obj.found !== false;
    var countRaw = found ? extractAvailableQtyFromNode(obj) : 0;
    var count = countRaw == null ? 0 : Math.max(0, Math.floor(countRaw));
    var optionsLen = found ? availableOptions.length : 0;
    if (!found) {
      availableOptions = [];
    }
    if (count > 0 && optionsLen > 0 && count !== optionsLen) {
      warnPdpDev('WMS count and availableOptions length differ; using safer lower max quantity', {
        sku: safeSku,
        count: count,
        availableOptions: optionsLen,
      });
      count = Math.min(count, optionsLen);
    } else if (count <= 0 && optionsLen > 0) {
      count = optionsLen;
    }

    var wmsApi = getWmsApi();
    var rawAvailableCount =
      obj.rawAvailableCount != null ? Math.max(0, Math.floor(Number(obj.rawAvailableCount) || 0)) : count;
    var storefrontStatus =
      obj.storefrontStatus ||
      (wmsApi && typeof wmsApi.getStorefrontStatus === 'function'
        ? wmsApi.getStorefrontStatus(rawAvailableCount, count)
        : count > 0
          ? 'AVAILABLE'
          : rawAvailableCount > 0
            ? 'ALL_IN_CART'
            : 'COMING_SOON');

    return {
      sku: safeSku,
      found: found,
      count: count,
      rawAvailableCount: rawAvailableCount,
      minWeight: found && count > 0 ? extractMinWeightFromNode(obj) : null,
      maxWeight: found && count > 0 ? toFiniteNumber(obj.maxWeight ?? obj.maximumWeight) : null,
      weightGroups: found && Array.isArray(obj.weightGroups) ? obj.weightGroups : [],
      availableOptions: availableOptions,
      storefrontStatus: storefrontStatus,
    };
  }

  function resolveMaxSelectableQuantity(wmsSkuData) {
    var count = Math.max(0, Math.floor(Number(wmsSkuData && wmsSkuData.count) || 0));
    var optionsLen = Array.isArray(wmsSkuData && wmsSkuData.availableOptions)
      ? wmsSkuData.availableOptions.length
      : 0;
    if (optionsLen > 0 && count > 0) return Math.min(count, optionsLen);
    if (optionsLen > 0) return optionsLen;
    return count;
  }

  /**
   * Central PDP row binder: visible text + datasets used by weight modal / ATC.
   * @param {HTMLElement} rowElement
   * @param {ReturnType<typeof normalizePdpWmsSkuData> | null} wmsSkuData
   * @param {{ isLoading?: boolean, variant?: any }} [options]
   */
  function updatePdpVariantRowFromWms(rowElement, wmsSkuData, options) {
    options = options || {};
    var row = rowElement;
    if (!(row instanceof HTMLElement)) return;

    var minWeightCell = row.querySelector('[data-premium-pdp-min-weight]');
    var stockCell = row.querySelector('[data-premium-pdp-stock]');
    var weightBtn = row.querySelector('[data-details-weight-open]');
    var weightLabel = row.querySelector('[data-details-weight-label]');
    var isLoading = options.isLoading === true;
    var displaySku = normalizeSkuDisplay(
      (wmsSkuData && wmsSkuData.sku) || row.dataset.variantSku || ''
    );

    if (isLoading) {
      row.dataset.wmsStatus = 'loading';
      row.dataset.rowState = 'loading';
      row.dataset.variantAvailable = 'false';
      row.dataset.variantInventoryQty = '0';
      row.classList.add('is-unavailable');
      row.setAttribute('aria-busy', 'true');
      var skeletonApi = getWmsApi();
      var minSkeleton =
        skeletonApi && typeof skeletonApi.getInventorySkeletonMarkup === 'function'
          ? skeletonApi.getInventorySkeletonMarkup('min-weight')
          : '<span class="aone-inventory-skeleton aone-inventory-skeleton--min-weight" aria-hidden="true"></span><span class="visually-hidden">Loading minimum weight</span>';
      var qtySkeleton =
        skeletonApi && typeof skeletonApi.getInventorySkeletonMarkup === 'function'
          ? skeletonApi.getInventorySkeletonMarkup('available-qty')
          : '<span class="aone-inventory-skeleton aone-inventory-skeleton--available-qty" aria-hidden="true"></span><span class="visually-hidden">Loading available quantity</span>';
      if (minWeightCell) {
        minWeightCell.innerHTML = minSkeleton;
        minWeightCell.setAttribute('aria-busy', 'true');
      }
      if (stockCell) {
        stockCell.innerHTML = qtySkeleton;
        stockCell.setAttribute('aria-busy', 'true');
      }
      if (weightLabel instanceof HTMLElement) {
        var weightSkeleton =
          skeletonApi && typeof skeletonApi.getInventorySkeletonMarkup === 'function'
            ? skeletonApi.getInventorySkeletonMarkup('weight-action')
            : '<span class="aone-inventory-skeleton aone-inventory-skeleton--weight-action" aria-hidden="true"></span>';
        weightLabel.innerHTML = weightSkeleton;
      }
      syncRowControls(row);
      return;
    }

    row.removeAttribute('aria-busy');
    if (minWeightCell) minWeightCell.removeAttribute('aria-busy');
    if (stockCell) stockCell.removeAttribute('aria-busy');

    if (!displaySku) {
      warnPdpDev('PDP variant row is missing a SKU; leaving row unavailable', {
        variantId: row.dataset.variantId || '',
      });
      row.dataset.wmsStatus = 'coming-soon';
      row.dataset.rowState = 'ready';
      row.dataset.variantAvailable = 'false';
      row.dataset.variantInventoryQty = '0';
      row.classList.add('is-unavailable');
      delete row.dataset.weightValue;
      delete row.dataset.serialNumbersValue;
      delete row.dataset.wmsOptionsJson;
      row.classList.remove('has-weight-selected');
      if (minWeightCell) minWeightCell.textContent = 'N/A';
      if (stockCell) stockCell.textContent = 'COMING SOON';
      if (weightLabel instanceof HTMLElement) weightLabel.textContent = 'Min wt: N/A';
      syncRowControls(row);
      return;
    }

    var data = wmsSkuData || normalizePdpWmsSkuData(null, displaySku);
    var maxQty = resolveMaxSelectableQuantity(data);
    var rawQty = Math.max(
      0,
      Math.floor(Number(data.rawAvailableCount != null ? data.rawAvailableCount : data.count) || 0)
    );
    var wmsApi = getWmsApi();
    var storefrontStatus =
      data.storefrontStatus ||
      (wmsApi && typeof wmsApi.getStorefrontStatus === 'function'
        ? wmsApi.getStorefrontStatus(rawQty, maxQty)
        : maxQty > 0
          ? 'AVAILABLE'
          : rawQty > 0
            ? 'ALL_IN_CART'
            : 'COMING_SOON');
    var available = storefrontStatus === 'AVAILABLE' && maxQty > 0;
    var allInCart = storefrontStatus === 'ALL_IN_CART';
    var minWeight = data.minWeight;
    // WMS-only: if we can't resolve a real WMS minimum weight, treat as coming-soon.
    available = available && minWeight != null && minWeight > 0;

    row.dataset.variantSku = displaySku;
    row.dataset.wmsStatus = available ? 'available' : allInCart ? 'all-in-cart' : 'coming-soon';
    row.dataset.rowState = 'ready';
    row.dataset.variantAvailable = available ? 'true' : 'false';
    row.dataset.variantInventoryQty = String(maxQty);
    row.classList.toggle('is-unavailable', !available);

    if (available && Array.isArray(data.availableOptions) && data.availableOptions.length) {
      try {
        row.dataset.wmsOptionsJson = JSON.stringify(data.availableOptions);
      } catch (_error) {
        delete row.dataset.wmsOptionsJson;
      }
    } else {
      delete row.dataset.wmsOptionsJson;
    }

    if (data.minWeight != null && data.minWeight > 0) {
      row.dataset.wmsMinWeight = String(data.minWeight);
    } else {
      delete row.dataset.wmsMinWeight;
    }
    if (data.maxWeight != null && data.maxWeight > 0) {
      row.dataset.wmsMaxWeight = String(data.maxWeight);
    } else {
      delete row.dataset.wmsMaxWeight;
    }

    if (minWeightCell) {
      minWeightCell.textContent =
        available && minWeight != null && minWeight > 0 ? formatWeight(minWeight) : 'N/A';
    }
    if (stockCell) {
      stockCell.textContent = available ? String(maxQty) : allInCart ? '0' : 'COMING SOON';
    }

    if (!available) {
      delete row.dataset.weightValue;
      delete row.dataset.serialNumbersValue;
      row.classList.remove('has-weight-selected');
      if (weightLabel instanceof HTMLElement) {
        weightLabel.textContent = 'Coming Soon';
      }
      if (weightBtn instanceof HTMLElement) {
        weightBtn.setAttribute('data-weight-idle-label', 'Coming Soon');
        weightBtn.classList.remove('is-confirmed');
      }
    } else if (weightLabel instanceof HTMLElement) {
      var selectedSerials = String(row.dataset.serialNumbersValue || '').trim();
      var minLabel =
        wmsApi && typeof wmsApi.formatMinimumWeightLabel === 'function'
          ? wmsApi.formatMinimumWeightLabel(minWeight)
          : minWeight != null && Number(minWeight) > 0
            ? 'Min wt: ' + formatWeight(minWeight)
            : 'Coming Soon';
      var actionLabel = selectedSerials ? 'Edit weight' : minLabel;
      if (weightBtn instanceof HTMLElement) {
        weightBtn.setAttribute('data-weight-idle-label', actionLabel);
        if (selectedSerials) weightBtn.classList.add('is-confirmed');
        else weightBtn.classList.remove('is-confirmed');
      }
      weightLabel.textContent = actionLabel || 'Coming Soon';
    }

    syncRowControls(row);
  }

  function extractMinWeightFromNode(node) {
    if (node == null) return null;
    var direct = toFiniteNumber(node);
    if (direct != null && direct > 0) return direct;
    if (Array.isArray(node)) {
      var min = null;
      for (var i = 0; i < node.length; i += 1) {
        var val = extractMinWeightFromNode(node[i]);
        if (val == null || val <= 0) continue;
        min = min == null ? val : Math.min(min, val);
      }
      return min;
    }
    if (typeof node !== 'object') return null;
    var obj = node;
    var keys = [
      'minWeight',
      'min_weight',
      'minimumWeight',
      'minimum_weight',
      'overallMinWeight',
      'weight',
      'weight_g',
    ];
    for (var k = 0; k < keys.length; k += 1) {
      var key = keys[k];
      if (!(key in obj)) continue;
      var candidate = extractMinWeightFromNode(obj[key]);
      if (candidate != null && candidate > 0) return candidate;
    }
    var nestedKeys = ['summary', 'data', 'payload', 'item', 'items', 'availableOptions', 'availableWeights'];
    for (var n = 0; n < nestedKeys.length; n += 1) {
      var nested = nestedKeys[n];
      if (!(nested in obj)) continue;
      var nestedVal = extractMinWeightFromNode(obj[nested]);
      if (nestedVal != null && nestedVal > 0) return nestedVal;
    }
    return null;
  }

  function extractAvailableQtyFromNode(node) {
    if (node == null) return null;
    if (Array.isArray(node)) return node.length;
    if (typeof node !== 'object') return null;
    var obj = node;
    var keys = [
      'count',
      'availableQty',
      'available_qty',
      'availableQuantity',
      'available_quantity',
      'totalAvailableQuantity',
      'stock',
      'qty',
      'quantity',
    ];
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      if (!(key in obj)) continue;
      var qty = toFiniteNumber(obj[key]);
      if (qty != null && qty >= 0) return Math.floor(qty);
    }
    var nestedKeys = ['availableOptions', 'availableWeights', 'items', 'data', 'summary'];
    for (var n = 0; n < nestedKeys.length; n += 1) {
      var nested = nestedKeys[n];
      if (!(nested in obj)) continue;
      var nestedQty = extractAvailableQtyFromNode(obj[nested]);
      if (nestedQty != null) return nestedQty;
    }
    return null;
  }

  function ensureWmsProductData(product) {
    var productId = normalizeShopifyId(product && product.id);
    if (!productId) return Promise.resolve();
    if (productLoadPromiseById.has(productId)) return productLoadPromiseById.get(productId);
    var api = window.AOneProductWeightsAPI || window.AoneBatchWeight;
    var availabilityApi = getWmsApi();
    var loadPromise =
      api && typeof api.loadCurrentProductWeights === 'function'
        ? api.loadCurrentProductWeights([productId])
        : Promise.resolve();
    var cartPromise =
      availabilityApi && typeof availabilityApi.ensureCartSerialsSynced === 'function'
        ? availabilityApi
            .ensureCartSerialsSynced(
              !(availabilityApi.isCartStateReady && availabilityApi.isCartStateReady())
            )
            .catch(function () {
              return null;
            })
        : Promise.resolve(null);
    var req = Promise.all([loadPromise, cartPromise]).finally(function () {
      productLoadPromiseById.delete(productId);
    });
    productLoadPromiseById.set(productId, req);
    return req;
  }

  function shopifyImageUrl(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.href);
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (e) {
      var q = src.indexOf('?');
      var base = q >= 0 ? src.slice(0, q) : src;
      return base + '?width=' + width;
    }
  }

  function shopifyImageSrcset(src, widths) {
    return widths
      .map(function (w) {
        return shopifyImageUrl(src, w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function getMediaBaseSrc(media) {
    if (!media) return '';
    if (typeof media.src === 'string' && media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    return '';
  }

  function buildGalleryViewerImages(product) {
    var images = [];
    var mediaList = Array.isArray(product && product.media) ? product.media : [];
    for (var i = 0; i < mediaList.length; i += 1) {
      var media = mediaList[i];
      if (!media || typeof media !== 'object') continue;
      var src = getMediaBaseSrc(media);
      if (!src) continue;
      images.push({
        src: shopifyImageUrl(src, 1600),
        alt: media.alt || '',
      });
    }
    return images;
  }

  function renderMainImage(main, opts) {
    var img = document.createElement('img');
    img.className = 'pdp-media__img plp-exp-media__img';
    img.setAttribute('data-plp-exp-main-img', '');
    img.loading = opts.eager ? 'eager' : 'lazy';
    if (opts.eager) img.setAttribute('fetchpriority', 'high');
    img.sizes = opts.sizes || PDP_MAIN_SIZES;
    img.alt = opts.alt || '';
    img.decoding = 'async';
    var baseSrc = opts.baseSrc || '';
    if (baseSrc) {
      img.src = opts.src || shopifyImageUrl(baseSrc, 1600);
      img.srcset = opts.srcset || shopifyImageSrcset(baseSrc, PDP_MAIN_WIDTHS);
    }
    if (img.complete) img.classList.add('pdp-media__img--loaded');
    else img.addEventListener('load', function () {
      img.classList.add('pdp-media__img--loaded');
    }, { once: true });
    main.innerHTML = '';
    main.appendChild(img);
  }

  function renderMainMedia(main, media, thumb, options) {
    options = options || {};
    if (!media) return;
    if (media.media_type === 'video' || media.media_type === 'external_video') {
      main.innerHTML = '';
      var vid = document.createElement('video');
      vid.className = 'pdp-media__video';
      vid.controls = true;
      vid.playsInline = true;
      if (media.sources && media.sources.length) {
        media.sources.forEach(function (s) {
          var source = document.createElement('source');
          source.src = s.url;
          source.type = s.mime_type || 'video/mp4';
          vid.appendChild(source);
        });
      }
      main.appendChild(vid);
      return;
    }
    var baseSrc = (thumb && thumb.getAttribute('data-pdp-full-src')) || getMediaBaseSrc(media);
    renderMainImage(main, {
      baseSrc: baseSrc,
      src: thumb && thumb.getAttribute('data-pdp-full-src'),
      srcset: thumb && thumb.getAttribute('data-pdp-full-srcset'),
      sizes: (thumb && thumb.getAttribute('data-pdp-full-sizes')) || PDP_MAIN_SIZES,
      alt: (thumb && thumb.getAttribute('data-pdp-alt')) || (media.alt && media.alt) || '',
      eager: !!options.eager,
    });
  }

  function initGallery(root, product) {
    var main = root.querySelector('[data-pdp-main-media]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var viewImagesBtn = root.querySelector('[data-plp-view-images]');
    if ((!main || !thumbs.length) && !(viewImagesBtn instanceof HTMLButtonElement)) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = Number(thumb.getAttribute('data-pdp-thumb'));
        if (!Number.isFinite(idx)) return;
        thumbs.forEach(function (t) {
          var active = Number(t.getAttribute('data-pdp-thumb')) === idx;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        var media = product.media && product.media[idx];
        if (media) renderMainMedia(main, media, thumb, { eager: false });
      });
    });

    if (viewImagesBtn instanceof HTMLButtonElement) {
      viewImagesBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var viewer = window.plpVariantDetails;
        if (!viewer || typeof viewer.openImageViewer !== 'function') return;
        var images = buildGalleryViewerImages(product);
        if (!images.length) return;
        var activeThumb = root.querySelector('[data-pdp-thumb].is-active');
        var activeIndex = activeThumb instanceof HTMLElement ? Number(activeThumb.getAttribute('data-pdp-thumb') || '0') : 0;
        if (!Number.isFinite(activeIndex) || activeIndex < 0) activeIndex = 0;
        viewer.openImageViewer(images, activeIndex, viewImagesBtn);
      });
    }
  }

  function initAccordion(root) {
    root.querySelectorAll('[data-pdp-acc-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-pdp-acc-item]');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');
        root.querySelectorAll('[data-pdp-acc-item]').forEach(function (i) {
          i.classList.remove('is-open');
        });
        if (willOpen) item.classList.add('is-open');
      });
    });
  }

  function setStatus(root, message, isError) {
    var status = root.querySelector('[data-premium-pdp-status]');
    if (!(status instanceof HTMLElement)) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
  }

  function parseOptionDefinitions(root) {
    var el = root.querySelector('[data-premium-pdp-option-definitions]');
    if (!el || !el.textContent) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function normalizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function getVariantOptionValueByPosition(variant, position) {
    var idx = Number(position) - 1;
    if (!Number.isFinite(idx) || idx < 0) return '';
    var direct = variant['option' + String(idx + 1)];
    if (direct != null && String(direct).trim()) return String(direct).trim();
    var opts = Array.isArray(variant.options) ? variant.options : [];
    return opts[idx] != null ? String(opts[idx]).trim() : '';
  }

  function extractNumericValue(raw) {
    var match = String(raw || '').match(/-?\d+(\.\d+)?/);
    if (!match) return null;
    var parsed = Number(match[0]);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function sortMatrixValues(values) {
    return values.slice().sort(function (a, b) {
      var aNum = extractNumericValue(a);
      var bNum = extractNumericValue(b);
      if (aNum != null && bNum != null && aNum !== bNum) return aNum - bNum;
      return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function detectMatrixConfig(optionDefs) {
    if (!Array.isArray(optionDefs)) return null;
    if (optionDefs.length < 2 || optionDefs.length > 3) return null;

    var widthDef = null;
    var lengthDef = null;
    optionDefs.forEach(function (def) {
      var key = normalizeKey(def && (def.key || def.name || ''));
      if (!widthDef && /(width|mm|thickness|gauge|diameter|dia)/.test(key)) widthDef = def;
      if (!lengthDef && /(length|inch|inches|len)/.test(key)) lengthDef = def;
    });

    var rowDef = widthDef || optionDefs[0];
    var colDef = lengthDef || optionDefs.find(function (d) {
      return d !== rowDef;
    }) || optionDefs[1];

    if (!rowDef || !colDef || rowDef === colDef) return null;

    var contextDefs = optionDefs.filter(function (def) {
      return def !== rowDef && def !== colDef;
    });
    if (contextDefs.length > 1) return null;

    return {
      rowDef: rowDef,
      colDef: colDef,
      contextDef: contextDefs.length ? contextDefs[0] : null,
    };
  }

  function chooseMatrixVariant(current, next) {
    // Keep first mapped variant stable. Do not prefer Shopify variant.available.
    if (!current) return next;
    return current;
  }

  function getMatrixStockStatus(wmsSkuDataOrQty) {
    var inventoryApi = window.WMSInventory || window.AOneWmsAvailability;
    var rawQty = 0;
    var effectiveQty = 0;
    var minWeight = null;

    if (wmsSkuDataOrQty && typeof wmsSkuDataOrQty === 'object') {
      effectiveQty = resolveMaxSelectableQuantity(wmsSkuDataOrQty);
      rawQty = Math.max(
        0,
        Math.floor(
          Number(
            wmsSkuDataOrQty.rawAvailableCount != null
              ? wmsSkuDataOrQty.rawAvailableCount
              : wmsSkuDataOrQty.count != null
                ? wmsSkuDataOrQty.count
                : effectiveQty
          ) || 0
        )
      );
      if (wmsSkuDataOrQty.found === false) rawQty = 0;
      minWeight = wmsSkuDataOrQty.minWeight;
    } else {
      effectiveQty = Number.isFinite(Number(wmsSkuDataOrQty))
        ? Math.max(0, Math.floor(Number(wmsSkuDataOrQty)))
        : 0;
      rawQty = effectiveQty;
    }

    if (inventoryApi && typeof inventoryApi.resolveVariantAvailabilityState === 'function') {
      var cartReady =
        typeof inventoryApi.isCartStateReady === 'function' ? inventoryApi.isCartStateReady() : true;
      var resolved = inventoryApi.resolveVariantAvailabilityState({
        rawWmsQty: rawQty,
        effectiveQty: effectiveQty,
        effectiveMinWeight: minWeight,
        isLoading: false,
        wmsResolved: true,
        cartResolved: cartReady,
      });

      // WMS-only: if we have qty but no real minimum weight, treat as coming-soon.
      if (resolved.state === 'available' && (!resolved.minimumWeight || !(Number(resolved.minimumWeight) > 0))) {
        return { key: 'coming-soon', label: 'COMING SOON', quantity: 0, minimumWeightLabel: 'Min wt: N/A' };
      }
      return {
        key: resolved.state,
        label: resolved.label,
        quantity: resolved.availableQuantity,
        minimumWeightLabel: resolved.minimumWeightLabel,
      };
    }

    var statusKey =
      inventoryApi && typeof inventoryApi.getStorefrontStatus === 'function'
        ? inventoryApi.getStorefrontStatus(rawQty, effectiveQty)
        : effectiveQty > 0
          ? 'AVAILABLE'
          : rawQty > 0
            ? 'ALL_IN_CART'
            : 'COMING_SOON';

    if (statusKey === 'ALL_IN_CART') {
      return { key: 'all-in-cart', label: 'AVAILABLE QTY: 0', quantity: 0, minimumWeightLabel: 'Min wt: N/A' };
    }
    if (statusKey === 'COMING_SOON' || effectiveQty <= 0) {
      return { key: 'coming-soon', label: 'COMING SOON', quantity: 0, minimumWeightLabel: 'Min wt: N/A' };
    }
    if (minWeight == null || Number(minWeight) <= 0) {
      return { key: 'coming-soon', label: 'COMING SOON', quantity: 0, minimumWeightLabel: 'Min wt: N/A' };
    }
    return {
      key: 'available',
      label: 'AVAILABLE QTY: ' + effectiveQty,
      quantity: effectiveQty,
      minimumWeightLabel:
        inventoryApi && typeof inventoryApi.formatMinimumWeightLabel === 'function'
          ? inventoryApi.formatMinimumWeightLabel(minWeight)
          : minWeight != null && Number(minWeight) > 0
            ? 'Min wt: ' + formatWeight(minWeight)
            : 'Min wt: N/A',
    };
  }

  function getMatrixCompactStatusText(status) {
    if (!status) return 'COMING SOON';
    if (status.key === 'available') return 'AVAILABLE: ' + status.quantity;
    if (status.key === 'all-in-cart') return 'QTY: 0';
    return 'COMING SOON';
  }

  function getInitialLayoutMode(root, optionDefs) {
    var layout = normalizeKey(root && root.dataset && root.dataset.variantLayout);
    if (layout === 'matrix' || layout === 'table') return layout;
    var detected = detectMatrixConfig(optionDefs);
    return detected ? 'matrix' : 'table';
  }

  function buildMatrixData(product, matrixConfig) {
    var rowDef = matrixConfig.rowDef;
    var colDef = matrixConfig.colDef;
    var contextDef = matrixConfig.contextDef;
    var rowSet = new Set();
    var colSet = new Set();
    var contextSet = new Set();
    var map = new Map();

    (product.variants || []).forEach(function (variant) {
      if (!variant || typeof variant !== 'object') return;
      var rowVal = getVariantOptionValueByPosition(variant, rowDef.position) || '—';
      var colVal = getVariantOptionValueByPosition(variant, colDef.position) || '—';
      var contextVal = contextDef ? (getVariantOptionValueByPosition(variant, contextDef.position) || '—') : '';
      rowSet.add(rowVal);
      colSet.add(colVal);
      if (contextDef) contextSet.add(contextVal);
      var key = [contextVal, rowVal, colVal].join('||');
      map.set(key, chooseMatrixVariant(map.get(key), variant));
    });

    return {
      rowValues: sortMatrixValues(Array.from(rowSet)),
      colValues: sortMatrixValues(Array.from(colSet)),
      contextValues: contextDef ? sortMatrixValues(Array.from(contextSet)) : [''],
      map: map,
      rowDef: rowDef,
      colDef: colDef,
      contextDef: contextDef,
    };
  }

  function getMatrixMaterialValue(variant, matrixData) {
    var defs = [matrixData.rowDef, matrixData.colDef, matrixData.contextDef].filter(Boolean);
    for (var i = 0; i < defs.length; i += 1) {
      var def = defs[i];
      if (normalizeKey(def.key || def.name) !== 'material') continue;
      return getVariantOptionValueByPosition(variant, def.position) || '';
    }
    return '';
  }

  function getCachedWmsBySku(product) {
    var skuMap = new Map();
    (product.variants || []).forEach(function (variant) {
      var displaySku = normalizeSkuDisplay(variant && variant.sku);
      var key = normalizeSku(displaySku);
      if (!key) return;
      var node = getCachedNodeForSku(product, displaySku);
      if (!node) return;
      if (node.__pdpInventoryPending) {
        skuMap.set(key, { sku: displaySku, pending: true });
        return;
      }
      skuMap.set(key, normalizePdpWmsSkuData(node, displaySku));
    });
    return skuMap;
  }

  function resolveVariantMinWeight(variant, wmsNode) {
    var fromWms = extractMinWeightFromNode(wmsNode);
    if (fromWms != null && fromWms > 0) return fromWms;
    var base = Number(variant && variant.weight);
    if (!Number.isFinite(base) || base <= 0) return null;
    var unit = normalizeKey(variant && variant.weight_unit);
    return unit === 'kg' ? base * 1000 : base;
  }

  function getAxisLabel(def) {
    var label = String(def.displayLabel || def.name || '').trim();
    var original = String(def.name || '').trim();
    var key = normalizeKey(def.key || def.name || '');
    if (key === 'width') {
      return 'WIDTH (MM)';
    }
    if (key === 'length') {
      return 'LENGTH (INCHES)';
    }
    return label || original.toUpperCase();
  }

  function normalizeContextValue(value) {
    return String(value == null ? '' : value)
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getMeaningfulContextValues(values) {
    var list = Array.isArray(values) ? values : [];
    var seen = Object.create(null);
    var output = [];
    for (var i = 0; i < list.length; i += 1) {
      var raw = normalizeContextValue(list[i]);
      if (!raw || raw === '—' || raw === '-') continue;
      var key = raw.toLowerCase();
      if (seen[key]) continue;
      seen[key] = true;
      output.push(raw);
    }
    return output;
  }

  function resetSummary(detailsRoot) {
    detailsRoot.querySelectorAll('[data-details-selected-count]').forEach(function (el) {
      el.textContent = '0';
    });
    detailsRoot.querySelectorAll('[data-details-total-qty]').forEach(function (el) {
      el.textContent = '0';
    });
    detailsRoot.querySelectorAll('[data-details-total-weight]').forEach(function (el) {
      el.textContent = '0.00g';
    });
    var addBtn = detailsRoot.querySelector('[data-details-add-selected]');
    if (addBtn instanceof HTMLButtonElement) addBtn.disabled = true;
  }

  function clearBulkSelections(detailsRoot) {
    var host = detailsRoot.closest('.plp-view-host');
    if (!(host instanceof HTMLElement)) return;
    if (!window.plpBulkSelection || typeof window.plpBulkSelection.clearProductVariants !== 'function') return;
    window.plpBulkSelection.clearProductVariants(host, detailsRoot);
  }

  function syncRowControls(row) {
    var input = row.querySelector('[data-details-qty-input]');
    var minus = row.querySelector('[data-details-qty-minus]');
    var plus = row.querySelector('[data-details-qty-plus]');
    var weightBtn = row.querySelector('[data-details-weight-open]');
    var available = row.dataset.variantAvailable === 'true';
    var max = Number(row.dataset.variantInventoryQty || 0);
    var qty = input instanceof HTMLInputElement ? Math.max(0, parseInt(input.value || '0', 10) || 0) : 0;
    if (input instanceof HTMLInputElement) {
      input.disabled = !available;
      input.max = String(Math.max(0, max));
      if (max >= 0 && qty > max) input.value = String(max);
      if (!available) input.value = '0';
    }
    if (minus instanceof HTMLButtonElement) minus.disabled = !available || qty <= 0;
    if (plus instanceof HTMLButtonElement) plus.disabled = !available || qty >= max;
    if (weightBtn instanceof HTMLButtonElement) weightBtn.disabled = !available;
  }

  function setActiveSku(root, sku) {
    var skuEl = root.querySelector('[data-premium-pdp-active-sku]');
    if (!(skuEl instanceof HTMLElement)) return;
    skuEl.textContent = sku || '—';
  }

  function isMatrixMobileViewport() {
    // Always keep the desktop matrix table. Mobile/tablet use CSS horizontal scroll
    // (.premium-pdp-matrix__scroll) instead of the card layout swap.
    return false;
  }

  /** @type {WeakMap<HTMLElement, any>} */
  var matrixRenderStateByRoot = new WeakMap();

  function bindMatrixViewportListener(root) {
    // No-op: do not re-render on viewport changes (would reset qty/weight state).
    // Layout is handled entirely by CSS horizontal scrolling.
    if (!(root instanceof HTMLElement)) return;
    root.dataset.matrixViewportBound = 'true';
  }

  /**
   * Measure the Length group header so the inch-value row sticks directly under it.
   * @param {HTMLElement} scrollEl
   */
  function syncMatrixStickyHeaderHeights(scrollEl) {
    if (!(scrollEl instanceof HTMLElement)) return;
    var groupHeader = scrollEl.querySelector('.premium-pdp-matrix__axis-group');
    var subHeader = scrollEl.querySelector('.premium-pdp-matrix__axis-column');
    if (groupHeader instanceof HTMLElement) {
      var mainHeight = Math.ceil(groupHeader.getBoundingClientRect().height);
      if (mainHeight >= 24 && mainHeight <= 80) {
        scrollEl.style.setProperty('--matrix-main-header-height', mainHeight + 'px');
      } else {
        scrollEl.style.removeProperty('--matrix-main-header-height');
      }
    }
    if (subHeader instanceof HTMLElement) {
      var subHeight = Math.ceil(subHeader.getBoundingClientRect().height);
      if (subHeight >= 24 && subHeight <= 80) {
        scrollEl.style.setProperty('--matrix-sub-header-height', subHeight + 'px');
      } else {
        scrollEl.style.removeProperty('--matrix-sub-header-height');
      }
    }
  }

  /**
   * @param {HTMLElement} matrixRoot
   */
  function bindMatrixStickyHeaderSync(matrixRoot) {
    if (!(matrixRoot instanceof HTMLElement)) return;
    var scroll = matrixRoot.querySelector('.premium-pdp-matrix__scroll');
    if (!(scroll instanceof HTMLElement)) return;
    syncMatrixStickyHeaderHeights(scroll);
    if (scroll.dataset.matrixStickyBound === 'true') return;
    scroll.dataset.matrixStickyBound = 'true';
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () {
        syncMatrixStickyHeaderHeights(scroll);
      });
      ro.observe(scroll);
      var table = scroll.querySelector('.premium-pdp-matrix__table');
      if (table instanceof HTMLElement) ro.observe(table);
    }
  }

  function buildMatrixCellModel(product, variant, rowVal, colVal, wmsBySku, options) {
    options = options || {};
    var isLoading = options.isLoading === true;
    var productId = normalizeShopifyId(product && product.id);
    var displaySku = normalizeSkuDisplay(variant && variant.sku);
    var skuKey = normalizeSku(displaySku);
    var wmsSkuData = !isLoading && skuKey ? wmsBySku.get(skuKey) : null;
    if (!isLoading && skuKey && !wmsSkuData) {
      var cachedNode = getCachedNodeForSku(product, displaySku);
      if (cachedNode && cachedNode.__pdpInventoryPending) {
        wmsSkuData = { sku: displaySku, pending: true };
      } else {
        wmsSkuData = normalizePdpWmsSkuData(cachedNode, displaySku);
      }
    }
    var rowPending = Boolean(wmsSkuData && wmsSkuData.pending);
    if (!isLoading && !rowPending && skuKey && (!wmsSkuData || wmsSkuData.found === false)) {
      wmsSkuData = normalizePdpWmsSkuData(
        {
          found: false,
          count: 0,
          rawAvailableCount: 0,
          availableOptions: [],
          storefrontStatus: 'COMING_SOON',
        },
        displaySku
      );
    }
    var availableQty = !isLoading && !rowPending ? resolveMaxSelectableQuantity(wmsSkuData) : 0;
    var status =
      isLoading || rowPending ? { key: 'loading' } : getMatrixStockStatus(wmsSkuData || availableQty);
    var showSkeleton = isLoading || rowPending || (status && status.key === 'loading');
    var weightActionLabel = showSkeleton
      ? ''
      : status && status.key === 'available' && status.minimumWeightLabel && !String(status.minimumWeightLabel).includes('N/A')
        ? status.minimumWeightLabel
        : 'Coming Soon';
    var materialValue = getMatrixMaterialValue(variant, options.matrixData || {});
    var rowAvailable =
      !showSkeleton && Boolean(skuKey) && status && status.key === 'available' && availableQty > 0;
    var cellState = showSkeleton ? 'loading' : status && status.key ? status.key : 'coming-soon';
    var wmsStatusAttr = showSkeleton
      ? 'loading'
      : rowAvailable
        ? 'available'
        : cellState === 'all-in-cart'
          ? 'all-in-cart'
          : cellState === 'error'
            ? 'error'
            : 'coming-soon';
    var skeletonApi = window.WMSInventory || window.AOneWmsAvailability;
    var statusSkeleton =
      skeletonApi && typeof skeletonApi.getInventorySkeletonMarkup === 'function'
        ? skeletonApi.getInventorySkeletonMarkup('status')
        : '<span class="aone-inventory-skeleton aone-inventory-skeleton--status" aria-hidden="true"></span><span class="visually-hidden">Loading availability</span>';
    var weightSkeleton =
      skeletonApi && typeof skeletonApi.getInventorySkeletonMarkup === 'function'
        ? skeletonApi.getInventorySkeletonMarkup('weight-action')
        : '<span class="aone-inventory-skeleton aone-inventory-skeleton--weight-action" aria-hidden="true"></span><span class="visually-hidden">Loading weight selection</span>';

    return {
      productId: productId,
      variant: variant,
      displaySku: displaySku,
      rowVal: rowVal,
      colVal: colVal,
      availableQty: availableQty,
      status: status,
      showSkeleton: showSkeleton,
      minWeightLabel: weightActionLabel,
      materialValue: materialValue || '',
      rowAvailable: rowAvailable,
      cellState: cellState,
      wmsStatusAttr: wmsStatusAttr,
      statusSkeleton: statusSkeleton,
      weightSkeleton: weightSkeleton,
      statusContent: showSkeleton
        ? statusSkeleton
        : '<span class="premium-pdp-matrix__status-row"><span class="premium-pdp-matrix__status-label premium-pdp-matrix__status-label--desktop">' +
          escapeHtml(status.label) +
          '</span><span class="premium-pdp-matrix__status-label premium-pdp-matrix__status-label--compact" aria-hidden="true">' +
          escapeHtml(getMatrixCompactStatusText(status)) +
          '</span><button type="button" class="premium-pdp-matrix__tip-btn" aria-label="' +
          escapeAttr('View SKU: ' + (displaySku || 'Unavailable')) +
          '" title="' +
          escapeAttr('SKU: ' + (displaySku || 'Unavailable')) +
          '"' +
          (displaySku ? '' : ' disabled') +
          '><svg class="premium-pdp-matrix__tip-icon" viewBox="0 0 16 16" width="13" height="13" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" stroke-width="1.25"></circle><circle cx="8" cy="5.25" r="0.9" fill="currentColor"></circle><path d="M8 7.35v3.9" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"></path></svg></button></span>',
      weightContent: showSkeleton
        ? weightSkeleton
        : '<span data-details-weight-label>' + escapeHtml(weightActionLabel) + '</span>',
    };
  }

  function renderMatrixVariantControls(cell) {
    var disabledAttr = cell.rowAvailable ? '' : ' disabled';
    var ariaDisabled = cell.rowAvailable ? '' : ' aria-disabled="true"';
    var qtyValue = cell.showSkeleton ? '' : '0';
    var qtyClass = cell.showSkeleton ? ' premium-pdp-matrix__qty-input--loading' : '';
    var safeRowVal = escapeAttr(cell.rowVal);
    var safeColVal = escapeAttr(cell.colVal);
    var safeAriaLabel = escapeAttr('Quantity for ' + cell.rowVal + ' x ' + cell.colVal);
    var safeWeightLabel = escapeAttr('Select weight for ' + cell.rowVal + ' and ' + cell.colVal);
    return (
      '<div class="premium-pdp-matrix__variant" data-details-variant-row data-variant-id="' +
      cell.variant.id +
      '" data-product-id="' +
      escapeAttr(cell.productId) +
      '" data-variant-sku="' +
      escapeAttr(cell.displaySku) +
      '" data-sku="' +
      escapeAttr(cell.displaySku) +
      '" data-variant-price-cents="' +
      (Number(cell.variant.price) || 0) +
      '" data-variant-available="' +
      (cell.rowAvailable ? 'true' : 'false') +
      '" data-row-option-value="' +
      safeRowVal +
      '" data-column-option-value="' +
      safeColVal +
      '" data-width="' +
      safeRowVal +
      '" data-length="' +
      safeColVal +
      '" data-selected-quantity="0" data-cell-state="' +
      cell.cellState +
      '" data-matrix-width="' +
      safeRowVal +
      '" data-matrix-length="' +
      safeColVal +
      '" data-variant-inventory-qty="' +
      cell.availableQty +
      '" data-wms-status="' +
      cell.wmsStatusAttr +
      '" data-jewelry-material="' +
      escapeAttr(cell.materialValue) +
      '">' +
      '<div class="premium-pdp-matrix__status premium-pdp-matrix__status--' +
      cell.cellState +
      '" role="status" aria-live="polite">' +
      cell.statusContent +
      '</div>' +
      '<div class="premium-pdp-matrix__qty-wrap" role="group" aria-label="' +
      safeAriaLabel +
      '"' +
      ariaDisabled +
      '>' +
      '<button type="button" class="order-sheet-details-qty__btn premium-pdp-matrix__qty-btn" data-details-qty-minus aria-label="Decrease quantity"' +
      disabledAttr +
      '>−</button>' +
      '<input type="number" class="order-sheet-details-qty__input premium-pdp-matrix__qty-input' +
      qtyClass +
      '" data-details-qty-input value="' +
      qtyValue +
      '" min="0" max="' +
      cell.availableQty +
      '" step="1" inputmode="numeric" aria-label="' +
      safeAriaLabel +
      '"' +
      disabledAttr +
      '>' +
      '<button type="button" class="order-sheet-details-qty__btn premium-pdp-matrix__qty-btn" data-details-qty-plus aria-label="Increase quantity"' +
      disabledAttr +
      '>+</button>' +
      '</div>' +
      '<div class="premium-pdp-matrix__weight-wrap">' +
      '<button type="button" class="order-sheet-details-variant-table__weight-btn premium-pdp-matrix__weight-btn" data-details-weight-open data-weight-idle-label="' +
      escapeAttr(cell.minWeightLabel || 'Select Weight') +
      '" aria-haspopup="dialog" aria-label="' +
      safeWeightLabel +
      '"' +
      disabledAttr +
      '>' +
      cell.weightContent +
      '</button>' +
      '</div></div>'
    );
  }

  function renderMatrixMobileCards(matrixRoot, matrixData, selectedContextValue, cellsByRow) {
    var mobile = matrixRoot.querySelector('[data-premium-matrix-mobile]');
    if (!(mobile instanceof HTMLElement)) return;
    var rowLabel = getAxisLabel(matrixData.rowDef);
    var colLabel = getAxisLabel(matrixData.colDef);
    var html = '';
    matrixData.rowValues.forEach(function (rowVal) {
      var cells = cellsByRow[rowVal] || [];
      html +=
        '<details class="premium-pdp-matrix-mobile__group" open>' +
        '<summary class="premium-pdp-matrix-mobile__summary">' +
        escapeHtml(rowLabel) +
        ': ' +
        escapeHtml(rowVal) +
        '</summary>' +
        '<div class="premium-pdp-matrix-mobile__cards">';
      cells.forEach(function (entry) {
        if (entry.missing) {
          html +=
            '<article class="premium-pdp-matrix-mobile__card premium-pdp-matrix-mobile__card--missing">' +
            '<p class="premium-pdp-matrix-mobile__meta">' +
            escapeHtml(colLabel) +
            ': ' +
            escapeHtml(entry.colVal) +
            '</p>' +
            '<p class="premium-pdp-matrix__status premium-pdp-matrix__status--coming-soon">Variant Not Available</p>' +
            '</article>';
          return;
        }
        html +=
          '<article class="premium-pdp-matrix-mobile__card premium-pdp-matrix-mobile__card--' +
          entry.cell.cellState +
          '">' +
          '<p class="premium-pdp-matrix-mobile__meta">' +
          escapeHtml(colLabel) +
          ': ' +
          escapeHtml(entry.colVal) +
          '</p>' +
          renderMatrixVariantControls(entry.cell) +
          '</article>';
      });
      html += '</div></details>';
    });
    mobile.innerHTML = html;
  }

  function syncMatrixLayoutMode(matrixRoot) {
    if (!(matrixRoot instanceof HTMLElement)) return;
    var mobileMode = isMatrixMobileViewport();
    var scroll = matrixRoot.querySelector('.premium-pdp-matrix__scroll');
    var mobile = matrixRoot.querySelector('[data-premium-matrix-mobile]');
    if (scroll instanceof HTMLElement) {
      scroll.hidden = mobileMode;
      if (mobileMode) scroll.setAttribute('inert', '');
      else scroll.removeAttribute('inert');
    }
    if (mobile instanceof HTMLElement) {
      mobile.hidden = !mobileMode;
      if (!mobileMode) mobile.setAttribute('inert', '');
      else mobile.removeAttribute('inert');
    }
  }

  function renderMatrix(root, product, detailsRoot, matrixData, selectedContextValue, wmsBySku, options) {
    options = options || {};
    var isLoading = options.isLoading === true;
    var matrixRoot = root.querySelector('[data-premium-pdp-matrix]');
    if (!(matrixRoot instanceof HTMLElement)) return;
    var head = matrixRoot.querySelector('[data-premium-matrix-head]');
    var body = matrixRoot.querySelector('[data-premium-matrix-body]');
    var countEl = matrixRoot.querySelector('[data-premium-matrix-variant-count]');
    if (!(head instanceof HTMLElement) || !(body instanceof HTMLElement) || !(countEl instanceof HTMLElement)) return;

    matrixRenderStateByRoot.set(root, {
      product: product,
      detailsRoot: detailsRoot,
      matrixData: matrixData,
      selectedContextValue: selectedContextValue,
      wmsBySku: wmsBySku,
      options: options,
    });
    bindMatrixViewportListener(root);

    var mobileMode = isMatrixMobileViewport();
    var rowLabel = getAxisLabel(matrixData.rowDef);
    var colLabel = getAxisLabel(matrixData.colDef);
    var colCount = matrixData.colValues.length;
    var headerHtml =
      '<tr><th scope="col" rowspan="2" class="premium-pdp-matrix__axis-corner"><span class="premium-pdp-matrix__axis-corner-label">' +
      escapeHtml(rowLabel) +
      '</span></th>' +
      '<th scope="col" colspan="' +
      colCount +
      '" class="premium-pdp-matrix__axis-group">' +
      escapeHtml(colLabel) +
      '</th></tr><tr>';
    matrixData.colValues.forEach(function (colVal) {
      headerHtml +=
        '<th scope="col" class="premium-pdp-matrix__axis-column">' + escapeHtml(colVal) + '</th>';
    });
    headerHtml += '</tr>';
    head.innerHTML = headerHtml;

    var matrixVariantCount = 0;
    var bodyHtml = '';
    /** @type {Record<string, Array<{ missing?: boolean, colVal: string, cell?: any }>>} */
    var cellsByRow = Object.create(null);

    matrixData.rowValues.forEach(function (rowVal) {
      cellsByRow[rowVal] = [];
      bodyHtml +=
        '<tr><th scope="row" class="premium-pdp-matrix__axis-row">' + escapeHtml(rowVal) + '</th>';
      matrixData.colValues.forEach(function (colVal) {
        var key = [selectedContextValue || '', rowVal, colVal].join('||');
        var variant = matrixData.map.get(key);
        if (!variant) {
          cellsByRow[rowVal].push({ missing: true, colVal: colVal });
          bodyHtml +=
            '<td class="premium-pdp-matrix__cell premium-pdp-matrix__cell--missing"><div class="premium-pdp-matrix__variant premium-pdp-matrix__variant--disabled"><div class="premium-pdp-matrix__status premium-pdp-matrix__status--coming-soon">Variant Not Available</div><div class="premium-pdp-matrix__qty-wrap"><button type="button" class="order-sheet-details-qty__btn premium-pdp-matrix__qty-btn" disabled>−</button><input type="number" class="order-sheet-details-qty__input premium-pdp-matrix__qty-input" value="0" min="0" step="1" disabled><button type="button" class="order-sheet-details-qty__btn premium-pdp-matrix__qty-btn" disabled>+</button></div><div class="premium-pdp-matrix__weight-wrap"><button type="button" class="order-sheet-details-variant-table__weight-btn premium-pdp-matrix__weight-btn" disabled><span>Select Weight</span></button></div></div></td>';
          return;
        }

        matrixVariantCount += 1;
        var cell = buildMatrixCellModel(product, variant, rowVal, colVal, wmsBySku, {
          isLoading: isLoading,
          matrixData: matrixData,
        });
        cellsByRow[rowVal].push({ colVal: colVal, cell: cell });
        bodyHtml +=
          '<td class="premium-pdp-matrix__cell premium-pdp-matrix__cell--' +
          cell.cellState +
          '">' +
          renderMatrixVariantControls(cell) +
          '</td>';
      });
      bodyHtml += '</tr>';
    });

    // Only one layout is interactive: avoid duplicate variant rows in DOM totals/ATC.
    if (mobileMode) {
      body.innerHTML = '';
      renderMatrixMobileCards(matrixRoot, matrixData, selectedContextValue, cellsByRow);
    } else {
      body.innerHTML = bodyHtml;
      var mobileHost = matrixRoot.querySelector('[data-premium-matrix-mobile]');
      if (mobileHost instanceof HTMLElement) mobileHost.innerHTML = '';
    }

    countEl.textContent =
      '(' + matrixVariantCount + (matrixVariantCount === 1 ? ' Variant' : ' Variants') + ')';
    syncMatrixLayoutMode(matrixRoot);
    bindMatrixStickyHeaderSync(matrixRoot);
  }

  function setupMatrixContext(root, detailsRoot, matrixData, product, wmsBySku, options) {
    options = options || {};
    var contextDef = matrixData.contextDef;
    var contextWrap = root.querySelector('[data-premium-matrix-context]');
    var contextLabel = root.querySelector('[data-premium-matrix-context-label]');
    var contextSelect = root.querySelector('[data-premium-matrix-context-select]');
    var contextSingle = root.querySelector('[data-premium-matrix-context-single]');
    var meaningfulContextValues = getMeaningfulContextValues(matrixData.contextValues);
    var preferredContext = String(options.preferredContext || '').trim();
    var selectedContext =
      preferredContext && meaningfulContextValues.indexOf(preferredContext) >= 0
        ? preferredContext
        : meaningfulContextValues[0] || '';

    if (
      contextDef &&
      meaningfulContextValues.length > 1 &&
      contextWrap instanceof HTMLElement &&
      contextSelect instanceof HTMLSelectElement
    ) {
      contextWrap.hidden = false;
      if (contextLabel instanceof HTMLElement) contextLabel.textContent = getAxisLabel(contextDef);
      contextSelect.innerHTML = meaningfulContextValues.map(function (value) {
        return '<option value="' + escapeAttr(value) + '">' + escapeHtml(value) + '</option>';
      }).join('');
      contextSelect.value = selectedContext;
      contextSelect.onchange = function () {
        clearBulkSelections(detailsRoot);
        selectedContext = contextSelect.value;
        renderMatrix(root, product, detailsRoot, matrixData, selectedContext, wmsBySku, options);
        resetSummary(detailsRoot);
      };
      if (contextSingle instanceof HTMLElement) contextSingle.hidden = true;
    } else {
      if (contextWrap instanceof HTMLElement) contextWrap.hidden = true;
      if (contextSingle instanceof HTMLElement) {
        if (contextDef && meaningfulContextValues.length === 1) {
          contextSingle.hidden = false;
          contextSingle.textContent = getAxisLabel(contextDef) + ': ' + meaningfulContextValues[0];
          selectedContext = meaningfulContextValues[0];
        } else {
          contextSingle.hidden = true;
        }
      }
    }

    renderMatrix(root, product, detailsRoot, matrixData, selectedContext, wmsBySku, options);
  }

  function hydrateListRows(root, product, detailsRoot, options) {
    options = options || {};
    var isLoading = options.isLoading === true;
    var rows = Array.prototype.slice.call(detailsRoot.querySelectorAll('[data-details-variant-row]'));
    var variantById = Object.create(null);
    (product.variants || []).forEach(function (variant) {
      if (!variant || variant.id == null) return;
      variantById[String(variant.id)] = variant;
    });

    rows.forEach(function (row) {
      if (!(row instanceof HTMLElement)) return;
      var displaySku = normalizeSkuDisplay(row.dataset.variantSku);
      var variant = variantById[String(row.dataset.variantId || '')] || null;

      if (isLoading) {
        updatePdpVariantRowFromWms(row, null, { isLoading: true, variant: variant });
        return;
      }

      if (!displaySku) {
        updatePdpVariantRowFromWms(row, null, { isLoading: false, variant: variant });
        return;
      }

      var node = getCachedNodeForSku(product, displaySku);
      if (node && node.__pdpInventoryPending) {
        updatePdpVariantRowFromWms(row, null, { isLoading: true, variant: variant });
        return;
      }
      if (!node) {
        warnPdpDev('No WMS SKU match for PDP row', {
          productId: normalizeShopifyId(product && product.id),
          sku: displaySku,
          variantId: row.dataset.variantId || '',
        });
      }
      var wmsSkuData = normalizePdpWmsSkuData(node, displaySku);
      updatePdpVariantRowFromWms(row, wmsSkuData, { isLoading: false, variant: variant });
    });

    resetSummary(detailsRoot);
    if (typeof detailsRoot.dispatchEvent === 'function') {
      detailsRoot.dispatchEvent(new CustomEvent('plp-details-qty-update', { bubbles: true }));
    }
  }

  function initVariantTable(root, product) {
    var panel = root.querySelector('[data-pdp-panel] .plp-view-host[data-plp-details-panel], .plp-view-host[data-plp-details-panel]');
    var detailsRoot = panel && panel.querySelector('[data-plp-expanded-details]');
    if (!(panel instanceof HTMLElement) || !(detailsRoot instanceof HTMLElement)) return;
    var matrixRoot = root.querySelector('[data-premium-pdp-matrix]');
    var listRoot = root.querySelector('[data-premium-pdp-list]');
    var optionDefs = parseOptionDefinitions(root);
    var matrixConfig = detectMatrixConfig(optionDefs);
    var layoutMode = getInitialLayoutMode(root, optionDefs);
    var useMatrix = layoutMode === 'matrix' && !!matrixConfig && matrixRoot instanceof HTMLElement;
    root.dataset.variantLayout = useMatrix ? 'matrix' : 'table';
    root.classList.toggle('premium-pdp--matrix', useMatrix);
    root.classList.toggle('premium-pdp--table', !useMatrix);

    var productId = normalizeShopifyId(product && product.id);
    var wmsApi = getWmsApi();
    if (wmsApi && typeof wmsApi.registerVariant === 'function') {
      (product.variants || []).forEach(function (variant) {
        if (!variant) return;
        var sku = normalizeSkuDisplay(variant.sku);
        if (!sku) return;
        wmsApi.registerVariant(String(variant.id), productId, sku);
      });
    }

    if (useMatrix) {
      if (listRoot instanceof HTMLElement) listRoot.hidden = true;
      if (matrixRoot instanceof HTMLElement) matrixRoot.hidden = false;
      var initialMatrixData = buildMatrixData(product, matrixConfig);
      if (initialMatrixData.rowValues.length > 0 && initialMatrixData.colValues.length > 0) {
        setupMatrixContext(root, detailsRoot, initialMatrixData, product, new Map(), { isLoading: true });
      } else if (matrixRoot instanceof HTMLElement) {
        var initialBody = matrixRoot.querySelector('[data-premium-matrix-body]');
        if (initialBody instanceof HTMLElement) {
          initialBody.innerHTML = '<tr><td colspan="999" class="premium-pdp-matrix__error-cell">No matrix variants available.</td></tr>';
        }
      }
    } else {
      if (matrixRoot instanceof HTMLElement) matrixRoot.hidden = true;
      if (listRoot instanceof HTMLElement) listRoot.hidden = false;
      hydrateListRows(root, product, detailsRoot, { isLoading: true });
    }

    if (window.plpVariantDetails && typeof window.plpVariantDetails.bindPanel === 'function') {
      window.plpVariantDetails.bindPanel(panel);
    }

    var onInteraction = function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var row = target.closest('[data-details-variant-row]');
      if (!(row instanceof HTMLElement)) return;
      var sku = normalizeSkuDisplay(row.dataset.variantSku);
      if (sku) setActiveSku(root, sku);
    };
    detailsRoot.addEventListener('click', onInteraction, true);
    detailsRoot.addEventListener('input', onInteraction, true);
    detailsRoot.addEventListener('change', onInteraction, true);

    var hydrateGeneration = (hydrateGenerationByRoot.get(root) || 0) + 1;
    hydrateGenerationByRoot.set(root, hydrateGeneration);

    ensureWmsProductData(product)
      .then(function () {
        if (hydrateGenerationByRoot.get(root) !== hydrateGeneration) return;
        if (!(root.isConnected)) return;

        var availabilityApi = getWmsApi();
        var cartReady =
          !availabilityApi ||
          typeof availabilityApi.isCartStateReady !== 'function' ||
          availabilityApi.isCartStateReady();
        if (!cartReady) {
          // Keep skeletons until cart reconciles; cart event will rehydrate.
          return;
        }

        if (useMatrix && matrixConfig && matrixRoot instanceof HTMLElement) {
          var wmsBySku = getCachedWmsBySku(product);
          var matrixData = buildMatrixData(product, matrixConfig);
          if (matrixData.rowValues.length > 0 && matrixData.colValues.length > 0) {
            matrixRoot.hidden = false;
            if (listRoot instanceof HTMLElement) listRoot.hidden = true;
            setupMatrixContext(root, detailsRoot, matrixData, product, wmsBySku, { isLoading: false });
            resetSummary(detailsRoot);
          } else {
            if (matrixRoot instanceof HTMLElement) matrixRoot.hidden = true;
            if (listRoot instanceof HTMLElement) listRoot.hidden = false;
            hydrateListRows(root, product, detailsRoot, { isLoading: false });
          }
        } else {
          if (matrixRoot instanceof HTMLElement) matrixRoot.hidden = true;
          if (listRoot instanceof HTMLElement) listRoot.hidden = false;
          hydrateListRows(root, product, detailsRoot, { isLoading: false });
        }

        setStatus(root, '', false);
      })
      .catch(function (error) {
        if (hydrateGenerationByRoot.get(root) !== hydrateGeneration) return;
        warnPdpDev('PDP products-batch hydrate failed', {
          productId: productId,
          error: error && error.message ? error.message : error,
        });
        if (matrixRoot instanceof HTMLElement && useMatrix) {
          var body = matrixRoot.querySelector('[data-premium-matrix-body]');
          if (body instanceof HTMLElement) {
            body.innerHTML = '<tr><td colspan="999" class="premium-pdp-matrix__error-cell">Unable to load variant details. Please try again.</td></tr>';
          }
          if (listRoot instanceof HTMLElement) listRoot.hidden = true;
          matrixRoot.hidden = false;
        } else {
          var rows = Array.prototype.slice.call(detailsRoot.querySelectorAll('[data-details-variant-row]'));
          rows.forEach(function (row) {
            if (!(row instanceof HTMLElement)) return;
            row.dataset.variantAvailable = 'false';
            row.dataset.variantInventoryQty = '0';
            row.dataset.wmsStatus = 'error';
            row.classList.add('is-unavailable');
            row.dataset.rowState = 'error';
            var minWeightCell = row.querySelector('[data-premium-pdp-min-weight]');
            var stockCell = row.querySelector('[data-premium-pdp-stock]');
            if (minWeightCell) minWeightCell.textContent = '—';
            if (stockCell) stockCell.textContent = 'Unavailable';
            delete row.dataset.weightValue;
            delete row.dataset.serialNumbersValue;
            delete row.dataset.wmsOptionsJson;
            row.classList.remove('has-weight-selected');
            syncRowControls(row);
          });
          resetSummary(detailsRoot);
        }
        setStatus(root, 'Inventory details are currently unavailable. Please try again.', true);
      });

    var controller = new AbortController();
    controllersByRoot.set(root, controller);
  }

  function resolveVariantById(product, variantIdValue) {
    var variantId = Number(variantIdValue);
    if (!Number.isFinite(variantId)) return null;
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i += 1) {
      var variant = variants[i];
      if (Number(variant && variant.id) === variantId) return variant;
    }
    return null;
  }

  function setPdpSubmitState(button, mode, label) {
    if (!(button instanceof HTMLButtonElement)) return;
    var text = button.querySelector('[data-pdp-atc-label]');
    if (text instanceof HTMLElement) text.textContent = label;
    var disabled = mode !== 'available';
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    button.setAttribute('aria-busy', mode === 'loading' ? 'true' : 'false');
    button.dataset.wmsStatus = mode;
  }

  function initStandardPdpFormGuard(root, product) {
    var form = root.querySelector('[data-pdp-product-form]');
    if (!(form instanceof HTMLFormElement)) return;
    if (root.querySelector('[data-premium-pdp-list], [data-premium-pdp-matrix]')) return;
    var submit = form.querySelector('[data-pdp-atc-submit]');
    if (!(submit instanceof HTMLButtonElement)) return;
    var variantIdInput = form.querySelector('[data-pdp-variant-id]');
    if (!(variantIdInput instanceof HTMLInputElement)) return;
    var availabilityApi = window.AOneWmsAvailability;
    if (!availabilityApi) return;

    var readContext = function () {
      var variant = resolveVariantById(product, variantIdInput.value);
      var productId = normalizeShopifyId(product && product.id);
      var sku = normalizeSku(variant && variant.sku);
      if (variant && sku) {
        availabilityApi.registerVariant(String(variant.id), productId, sku);
      }
      return {
        productId: productId,
        variantId: variant ? String(variant.id) : String(variantIdInput.value || ''),
        sku: sku,
      };
    };

    var syncState = function () {
      setPdpSubmitState(submit, 'loading', 'CHECKING AVAILABILITY');
      var context = readContext();
      availabilityApi
        .guardVariantAdd({
          productId: context.productId,
          variantId: context.variantId,
          sku: context.sku,
          quantity: Number((form.querySelector('input[name="quantity"]') || {}).value || 1) || 1,
        })
        .then(function (guard) {
          if (guard && guard.ok) {
            setPdpSubmitState(submit, 'available', 'ADD TO CART');
            return;
          }
          if (guard && guard.type === 'coming-soon') {
            setPdpSubmitState(submit, 'coming-soon', 'COMING SOON');
            return;
          }
          if (guard && guard.type === 'loading') {
            setPdpSubmitState(submit, 'loading', 'CHECKING AVAILABILITY');
            return;
          }
          setPdpSubmitState(submit, 'error', 'AVAILABILITY UNAVAILABLE');
        })
        .catch(function () {
          setPdpSubmitState(submit, 'error', 'AVAILABILITY UNAVAILABLE');
        });
    };

    syncState();
    form.addEventListener('change', syncState);

    form.addEventListener('submit', function (event) {
      if (form.dataset.wmsValidatedSubmit === 'true') return;
      event.preventDefault();
      event.stopPropagation();
      setPdpSubmitState(submit, 'loading', 'CHECKING AVAILABILITY');
      var context = readContext();
      availabilityApi
        .guardVariantAdd({
          productId: context.productId,
          variantId: context.variantId,
          sku: context.sku,
          quantity: Number((form.querySelector('input[name="quantity"]') || {}).value || 1) || 1,
          forceCartRefresh: true,
        })
        .then(function (guard) {
          if (!guard || !guard.ok) {
            if (guard && guard.type === 'coming-soon') {
              setPdpSubmitState(submit, 'coming-soon', 'COMING SOON');
            } else if (guard && guard.type === 'loading') {
              setPdpSubmitState(submit, 'loading', 'CHECKING AVAILABILITY');
            } else {
              setPdpSubmitState(submit, 'error', 'AVAILABILITY UNAVAILABLE');
            }
            setStatus(root, guard && guard.message ? guard.message : 'Availability unavailable', true);
            return;
          }
          setStatus(root, '', false);
          form.dataset.wmsValidatedSubmit = 'true';
          form.submit();
        })
        .catch(function () {
          setPdpSubmitState(submit, 'error', 'AVAILABILITY UNAVAILABLE');
          setStatus(root, 'Availability unavailable', true);
        });
    });
  }

  function boot(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.dataset.premiumPdpInitialized === 'true') return;
    root.dataset.premiumPdpInitialized = 'true';
    var product = parseProduct(root);
    if (!product) return;
    initGallery(root, product);
    initVariantTable(root, product);
    initStandardPdpFormGuard(root, product);
    initAccordion(root);
  }

  function destroy(root) {
    var controller = controllersByRoot.get(root);
    if (controller) controller.abort();
    controllersByRoot.delete(root);
    if (root instanceof HTMLElement) {
      hydrateGenerationByRoot.set(root, (hydrateGenerationByRoot.get(root) || 0) + 1);
      delete root.dataset.premiumPdpInitialized;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-section]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  function rehydratePdpInventoryFromCart() {
    document.querySelectorAll('[data-pdp-section]').forEach(function (root) {
      if (!(root instanceof HTMLElement)) return;
      var detailsRoot =
        root.querySelector('[data-premium-pdp-details], [data-plp-expanded-details], [data-details-root]') ||
        root;
      if (!(detailsRoot instanceof HTMLElement)) return;
      var product = parseProduct(root);
      if (!product) return;

      var availabilityApi = getWmsApi();
      var cartReady =
        !availabilityApi ||
        typeof availabilityApi.isCartStateReady !== 'function' ||
        availabilityApi.isCartStateReady();

      var matrixRoot = root.querySelector('[data-premium-pdp-matrix]');
      var listRoot = root.querySelector('[data-premium-pdp-list]');
      var optionDefs = parseOptionDefinitions(root);
      var matrixConfig = detectMatrixConfig(optionDefs);
      var useMatrix =
        root.dataset.variantLayout === 'matrix' &&
        !!matrixConfig &&
        matrixRoot instanceof HTMLElement &&
        !matrixRoot.hidden;

      // Preserve context selection across cart-driven rehydrates.
      var contextSelect = root.querySelector('[data-premium-matrix-context-select]');
      var preservedContext =
        contextSelect instanceof HTMLSelectElement ? String(contextSelect.value || '') : '';

      if (!cartReady) {
        if (useMatrix && matrixConfig) {
          var pendingMatrix = buildMatrixData(product, matrixConfig);
          if (pendingMatrix.rowValues.length > 0 && pendingMatrix.colValues.length > 0) {
            setupMatrixContext(root, detailsRoot, pendingMatrix, product, new Map(), {
              isLoading: true,
              preferredContext: preservedContext,
            });
          }
        } else {
          hydrateListRows(root, product, detailsRoot, { isLoading: true });
        }
        return;
      }

      if (useMatrix && matrixConfig) {
        var wmsBySku = getCachedWmsBySku(product);
        var matrixData = buildMatrixData(product, matrixConfig);
        if (matrixData.rowValues.length > 0 && matrixData.colValues.length > 0) {
          setupMatrixContext(root, detailsRoot, matrixData, product, wmsBySku, {
            isLoading: false,
            preferredContext: preservedContext,
          });
          if (typeof detailsRoot.dispatchEvent === 'function') {
            detailsRoot.dispatchEvent(new CustomEvent('plp-details-qty-update', { bubbles: true }));
          }
          return;
        }
      }
      if (listRoot instanceof HTMLElement || !useMatrix) {
        hydrateListRows(root, product, detailsRoot, { isLoading: false });
      }
    });
  }

  if (document.documentElement.dataset.aonePdpCartInventoryBound !== 'true') {
    document.documentElement.dataset.aonePdpCartInventoryBound = 'true';
    var availabilityApi = window.AOneWmsAvailability || window.WMSInventory;
    var eventName =
      (availabilityApi && availabilityApi.CART_INVENTORY_EVENT) || 'aone:cart-inventory-updated';
    document.addEventListener(eventName, function (event) {
      var detail = event && event.detail ? event.detail : null;
      if (detail && (detail.loading === true || detail.cartReady === false)) {
        rehydratePdpInventoryFromCart();
        return;
      }
      rehydratePdpInventoryFromCart();
    });
  }

  window.aonePremiumPdpRehydrateInventory = rehydratePdpInventoryFromCart;

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target instanceof Element ? event.target : null;
    if (!section) return;
    section.querySelectorAll('[data-pdp-section]').forEach(boot);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target instanceof Element ? event.target : null;
    if (!section) return;
    section.querySelectorAll('[data-pdp-section]').forEach(destroy);
  });
})();
